import { createForm } from '../../../factories'

export default createForm(['name', 'description', 'image', 'imageName', 'imageID'])



// WEBPACK FOOTER //
// ./src/store/modules/components/forms/store.js